import { render, staticRenderFns } from "./TheNotificationDisplayer.vue?vue&type=template&id=af059c30&scoped=true&"
import script from "./TheNotificationDisplayer.vue?vue&type=script&lang=ts&"
export * from "./TheNotificationDisplayer.vue?vue&type=script&lang=ts&"
import style0 from "./TheNotificationDisplayer.vue?vue&type=style&index=0&id=af059c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af059c30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
